import React, { useState } from 'react';
import './Footer.css';
import { PRIVACY_POLICY_LINKS, ContactModal } from './FooterLinks';
import USFLAG from '../../images/us-flag.jpg';

function Footer() {
	const [modal, setModal] = useState(false);
	const toggle = () => {
		setModal(!modal);
	};
	return (
		<div className='Footer'>
			{modal && (
				<ContactModal
					modal={modal}
					toggle={() => {
						toggle();
					}}
					message='For any issues, email SISC-GISC-IN-DoorKeeper@sony.com. Include the website, your name, email address,company name and the issue.'
				/>
			)}
			
			<ul className='Footer__links'>
			
				{PRIVACY_POLICY_LINKS.map((linkObj, index) => (
					<li className='Footer__link' key={index}>
						<a
							href={linkObj['url']}
							target='_blank'
							rel='noopener noreferrer'
							style={{
								fontWeight: 'bold',
								color: '#ccc',
								fontSize: '0.8rem',
							}}
							aria-label={linkObj['label']}>
							{linkObj['label']} |
						</a>
					</li>
				))}
				
				<li className='USFlagLogo' key={'flag'}>
					<img src={USFLAG} alt={'USFLAG'} />
				</li>

			</ul>
			
		</div>
	);
}

export default Footer;
